export const gridOptions = {
  sideBar: {
    toolPanels: [
      {
        iconKey: 'columns',
        id: 'columns',
        labelDefault: 'Columns',
        labelKey: 'columns',
        toolPanel: 'agColumnsToolPanel',
        toolPanelParams: {
          suppressPivotMode: true,
          suppressPivots: true,
          suppressRowGroups: true,
          suppressValues: true,
        },
      },
      {
        iconKey: 'filter',
        id: 'filters',
        labelDefault: 'Filters',
        labelKey: 'filters',
        toolPanel: 'agFiltersToolPanel',
      },
    ],
  },
  statusBar: {
    statusPanels: [
      {
        statusPanel: 'agAggregationComponent',
      },
    ],
  },
};
